import { html } from "htm/preact";
import { hydrate } from "preact";
import MuxModal from "../components/MuxModal.js";

const containers = document.querySelectorAll("[data-modal-video]");

containers.forEach((el) => {
  hydrate(html`<${MuxModal} />`, el);
})